module.exports = __webpack_public_path__ + "img/bt.bt4ded667.svg";